import React from 'react';
import { Card, CardBody, Row } from 'reactstrap';
import classnames from 'classnames';
import { Colxx } from '../../components/common/CustomBootstrap';

class ComponentToPrint extends React.Component {
    componentWillUnmount() {
        document.body.classList.remove('noscroll');
    }

    render() {
        let {
            item
        } = this.props;
        // console.log('item: ', item);

        return (<Row className='invoice-react  w-100' id='bill-to-print-tem'>
                <Colxx xxs='12' className='mb-4'>
                    <Card
                        className={classnames('mb-5 invoice-contents p-2  w-100', {
                            // card: !cardWrapper,
                        })}
                    >
                        <CardBody>
                            <div className='d-flex flex-column align-items-center justify-content-center p-1 text-muted w-100'>
                                <p>IIIIIIIIIIIIIIIIIIIIII</p>
                                <p className='w-100'>Quần Jean Heboz - 399.000đ</p>
                            </div>
                        </CardBody>
                    </Card>
                </Colxx>
            </Row>)
    }
}

export default ComponentToPrint;
